import { useCallback, useState } from "react";
import { errorMessage } from "../lib/errors";

/** Runs one mutation at a time and keeps its pending flag and error message for the UI. */
export function useAction<A extends unknown[], R>(fn: (...args: A) => Promise<R>) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const run = useCallback(async (...args: A): Promise<R | undefined> => {
    setPending(true);
    setError(null);
    try {
      return await fn(...args);
    } catch (e) {
      setError(errorMessage(e));
      return undefined;
    } finally {
      setPending(false);
    }
  }, [fn]);

  return { run, pending, error, clearError: () => setError(null) };
}
